import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { RouteConfig } from 'aurelia-router';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/um/services/auth-service';
import { I18N } from 'aurelia-i18n';
import { IAuthSummaryModelData } from 'app/um/components/summary/auth-summary';
import * as UM from 'app/um/models/essette-api';

@autoinject()
export class AuthSummaryPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    private auth: UM.Auth | null = null;
    protected modelData: IAuthSummaryModelData | null = null;
    protected isProviderPortal: boolean = false;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        private readonly i18n: I18N,
        ...rest: any[]) {

        super(...rest);
    }

    protected async activate(params: { authId: string }, routeConfig: RouteConfig): Promise<void> {
        if(!params?.authId) {
            throw new Error('Missing required parameters: authId');
        }

        this.isProviderPortal = this.env.application.code === 'Portal.Providers';

        await this.reload(params.authId);

        if(this.auth && routeConfig.navModel) {
            const title = this.i18n.tr('um:routes.auth.summary.$title', { number: this.auth.number });
            routeConfig.navModel.setTitle(title);
        }
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public async reload(authId: string): Promise<void> {
        await this.loadAuth(authId);
        if(!this.auth) {
            throw new Error('Unable to load auth');
        }
        this.modelData = {
            auth: this.auth,
            readonly: true
        };
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(authId: string): Promise<void> {
        if(!authId) return;

        const fields = [
            'number'
        ];

        try {
            this.state.beginLoad();

            const response = await this.authService.loadAuth(authId, [], {}, fields);
            this.auth = response.results[0];
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
